import { useForm } from 'react-hook-form';

import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';

import { Typography, Box } from '@mui/material';
import MuiDialog from 'components/MuiDialog';

import { SurveyDialogProps, TColonoscopyDefaultValues } from '../../type';
import { updateColonoscopy } from 'apis/survey';

import CommonPatientInfo from '../../components/CommonPatientInfo';
import Signature from './Signature';
import GeneralPateintConsentForm from './GeneralPateintConsentForm';

const PatientConsentForm = (
  props: SurveyDialogProps<TColonoscopyDefaultValues>
) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();
  const { handleSubmit, watch, getValues, setValue, register } = useForm({
    defaultValues,
  });

  const onSubmit = (data: TColonoscopyDefaultValues) => {
    const { companion_name, companion_sig, dr_name, dr_sig } = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      colono_scopy_confirmation: {
        companion_name,
        companion_sig,
        dr_name,
        dr_sig,
      },
    };

    // console.log('리퀘스트', request);

    updateColonoscopy(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);

        onUpdateIsSave(true);
        onSuccess('Амжилттай хадгалагдлаа');
      })
      .catch(e => {
        onFail('Хадгалж чадсангүй', e);
      });
  };

  const formProps = {
    disabled,
    watch,
    getValues,
    setValue,
    onSuccess,
    onRequired,
    register,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Typography
        sx={{
          margin: '40px auto 40px auto',
          fontWeight: '700',
          fontSize: '16px',
          textAlign: 'center',
        }}
      >
        General Patient Consent Form
      </Typography>
      <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
      <Box sx={{ marginTop: '48px' }}>
        <GeneralPateintConsentForm {...formProps} />
        <Box sx={{ margin: '20px auto 0px auto', width: '98%' }}>
          <Signature {...formProps} />
        </Box>
      </Box>
    </MuiDialog.SurveyForm>
  );
};

export default PatientConsentForm;
